Facet = LP.module('Searches').Facet
ParamStore = LP.module('Searches').ParamStore

class FacetStore extends FluxBaseStore
  @storeName = 'FacetStore'

  @handlers =
    TOGGLE_FACET:   'toggle'
    RECEIVE_FACETS: 'load'
    RECEIVE_SEARCH: 'resetActiveOnFacets'
    CLEAR_ALL:      'toggleAllActive'
    TOGGLE_FACET_EXPAND: 'toggleExpand'
    TOGGLE_PANEL_SHOW_MORE: 'collapseFacets'
    HIDE_FACETS:   'hideFacets'
    CLEAR_SIDEBAR: 'clear'

  initialize: ->
    @_facets = {}

  clear: ->
    @initialize()
    @emitChange()

  load: ({rawFacets}) ->
    existingFacets = $.extend({}, @_facets)
    for key, array of rawFacets
      @_facets[key] = []
      for facet in array
        if existingFacets[key] && key != 'lexile-measures'
          f = undefined
          for parentFacet in existingFacets[key]
            if parentFacet.id == facet.id
              f = parentFacet
              break
          facet.expanded = f.expanded || false if f
        @_facets[key].push new Facet($.extend(key: key, paramStore: @dispatcher.getStore('ParamStore'), facet))

    @emitChange()

  resetActiveOnFacets: ({rawSearch, paramsDidChange}) ->
    @dispatcher.waitFor 'ParamStore', =>
      if paramsDidChange
        @_setActive facets for key, facets of @_facets
        @emitChange()

  toggleExpand: ({facet}) ->
    facet.expanded = !facet.expanded
    @emitChange()

  toggle: ({facet}) ->
    return if facet.disabled and !facet.active
    facet.active = !facet.active
    facet.parent.active = facet.active if facet.isChild and facet.isSelectAll
    facet.children[0].active = facet.active if facet.isParent
    @_deactivateSelectAllSiblings(facet) if facet.active and facet.isChild
    # when the parent (non expanded) facet is clicked, we need to clear any selected children.
    @_deactivateSelectectedSiblings(facet) if facet.active and facet.isParent
    @_deactivateAllSiblings(facet) if facet.active and facet.key in ParamStore.singleValFacets

    @emitChange()

  hideFacets: ({facets}) ->
    for facet in facets
      facet.hidden = !facet.hidden
    @emitChange()

  collapseFacets: ({key}) ->
    if @_facets[key]
      for facet in @_facets[key]
        facet.expanded = false
      @emitChange()

  toggleAllActive: ->
    activeFacets = @active(@dispatcher.getStore('ParamStore').activeFacetContexts())
    for facet in activeFacets
      facet.parent.expanded = false if facet.isChild
      facet.expanded = false if facet.isParent
      @toggle facet: facet

  get: (key, {sorted} = {sorted: true}) ->
    facets = @_facets[key] || []
    if sorted then @_sort(facets) else facets

  active: (keys) ->
    keys = [keys] unless Array.isArray keys
    facets = []
    for key in keys
      loadedFacets = @get key
      facets = facets.concat @_findActiveFacets(loadedFacets)
    facets

  _findActiveFacets: (facets) ->
    matches = []
    for facet in facets
      matches.push facet if facet.active && !facet.hidden && !facet.isParent
      matches = matches.concat @_findActiveFacets(facet.children) if facet.isParent
    matches

  _sort: (facets) ->
    [top, bottom] = facets.reduce (memo, facet) ->
      memo[+(facet.count is 0 and not facet.isSelectAll)].push facet; memo
    , [[],[]]

    (top.concat(bottom)).map((facet) =>
      facet.children = @_sort(facet.children) if facet.isParent
      facet
    )

  _setActive: (facets) ->
    for facet in facets
      facet.active = @dispatcher.getStore('ParamStore').isActive facet.key, facet.id
      @_setActive facet.children if facet.isParent

  _deactivateSelectAllSiblings: (facet) ->
    @toggle facet: sibling for sibling in facet.parent.children when sibling.active and sibling.isSelectAll isnt facet.isSelectAll

  _deactivateSelectectedSiblings: (facet) ->
    @toggle facet: sibling for sibling in facet.children when sibling.active and !sibling.isSelectAll

  _deactivateAllSiblings: (facet) ->
    @toggle facet: sibling for sibling in @get(facet.key, sorted: false) when sibling.active and sibling.id isnt facet.id

LP.module('Searches').FacetStore = FacetStore
